export const PROPERTY_TYPES = [
  { value: "sous-sol_commercial", label: "Sous-sol commercial" },
  { value: "cave", label: "Cave" },
  { value: "parking", label: "Parking" },
  { value: "reserve", label: "Réserve" },
  { value: "coffre", label: "Ancien coffre / banque" },
  { value: "local_technique", label: "Local technique" },
  { value: "niveau_-1", label: "Niveau -1 d'un commerce" },
  { value: "autre", label: "Autre" },
];

export const USE_CASES = [
  { value: "stockage", label: "Stockage" },
  { value: "archives", label: "Archives" },
  { value: "salle_sport", label: "Salle de sport" },
  { value: "studio_photo", label: "Studio photo" },
  { value: "studio_podcast", label: "Studio podcast" },
  { value: "escape_game", label: "Escape game" },
  { value: "vr", label: "Réalité virtuelle" },
  { value: "evenementiel", label: "Événementiel" },
  { value: "bar_club", label: "Bar / club privé" },
  { value: "cave_vin", label: "Cave à vin" },
  { value: "showroom", label: "Showroom" },
  { value: "dark_kitchen", label: "Dark kitchen" },
  { value: "atelier", label: "Atelier" },
  { value: "reserve_commerce", label: "Réserve commerce" },
  { value: "data", label: "Data / serveur" },
  { value: "autre", label: "Autre" },
];

export const OFFER_TYPES = [
  { value: "location", label: "Location" },
  { value: "vente", label: "Vente" },
  { value: "bail_commercial", label: "Bail commercial" },
  { value: "bail_precaire", label: "Bail précaire" },
  { value: "mise_a_dispo", label: "Mise à disposition" },
  { value: "revenue_share", label: "Partenariat / revenue share" },
];

export const CONTACT_ROLES = [
  { value: "proprietaire", label: "Propriétaire" },
  { value: "agent", label: "Agent immobilier" },
  { value: "asset_manager", label: "Asset manager" },
  { value: "syndic", label: "Syndic" },
  { value: "exploitant", label: "Exploitant" },
  { value: "autre", label: "Autre" },
];

export function scoreLabel(score) {
  if (score >= 80) return { label: "TRÈS EXPLOITABLE", color: "text-emerald-400", ring: "ring-emerald-500/40" };
  if (score >= 55) return { label: "POTENTIEL INTÉRESSANT", color: "text-amber-400", ring: "ring-amber-500/40" };
  if (score >= 30) return { label: "USAGE LIMITÉ", color: "text-orange-400", ring: "ring-orange-500/40" };
  return { label: "USAGE RESTREINT", color: "text-zinc-400", ring: "ring-zinc-600/40" };
}
